export default {
  categories: {
    id: 'menu_categories',
    defaultMessage: 'Categories',
  },
  see_all: {
    id: 'menu_see_all',
    defaultMessage: 'See all',
  },
  goodDeals: {
    id: 'menu_good_deals',
    defaultMessage: 'Good deals',
  },
  linkTradeIn: {
    id: 'mweb_nav_to_buyback',
    defaultMessage: 'Sell your tech',
  },
  shop: {
    id: 'mweb_nav_to_shop',
    defaultMessage: 'Shop',
  },
  linkAboutUs: {
    id: 'mweb_nav_to_about_us',
    defaultMessage: 'About us',
  },
  linkVerifiedRefurbished: {
    id: 'header_to_verified_refurbished',
    defaultMessage: 'Verified Refurbished',
  },
  linkBackStories: {
    id: 'header_to_back_stories',
    defaultMessage: 'Back Stories',
  },
  linkHelp: {
    id: 'mweb_nav_to_help',
    defaultMessage: 'Help',
  },
  aboutUs: {
    id: 'header_to_about_us',
    defaultMessage: 'About us',
  },
  sellYourTech: {
    id: 'header_to_buyback',
    defaultMessage: 'Sell your tech',
  },
  help: {
    id: 'header_to_help',
    defaultMessage: 'Help',
  },
  verifiedRefurbished: {
    id: 'header_to_verified_refurbished',
    defaultMessage: 'Verified Refurbished',
  },
  backStories: {
    id: 'header_to_back_stories',
    defaultMessage: 'Back Stories',
  },

  tradeInTitle_smartphones: {
    id: 'menu_trade-in_title_smartphones',
    defaultMessage: 'Trade-in',
  },
  tradeInDescription_smartphones: {
    id: 'menu_trade-in_description_smartphones',
    defaultMessage: 'Get up to $900 for your old device',
  },
  mobilePlanTitle_smartphones: {
    id: 'menu_mobile-plan_title_smartphones',
    defaultMessage: 'Exclusive deals',
  },
  mobilePlanDescription_smartphones: {
    id: 'menu_mobile-plan_description_smartphones',
    defaultMessage: 'Select a Visible+ plan at checkout and save',
  },
  tradeInTitle_laptops: {
    id: 'menu_trade-in_title_laptops',
    defaultMessage: 'Trade-in',
  },
  tradeInDescription_laptops: {
    id: 'menu_trade-in_description_laptops',
    defaultMessage: 'Get up to $900 for your old device',
  },
  goodToKnow: {
    id: 'good_to_know',
    defaultMessage: 'Good to know',
  },
}
